import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import actions from './actions';

export const initialState = {
  suburbs: [],
  isFetching: false,
  error: null
};

const reducer = handleActions({
  [actions.geonames.api.suburbs.get.request]: (state, action) => {
    return Object.assign({}, state, {
      suburbs: [],
      isFetching: true
    });
  },
  [actions.geonames.api.suburbs.get.success]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      suburbs: action.payload.suburbs,
      error: null
    });
  },
  [actions.geonames.api.suburbs.get.failed]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      error: action.payload.error
    });
  },
  [LOCATION_CHANGE]: (state, action) => {
    return Object.assign({}, state, initialState);
  }
}, {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/geonames/reducers.js